import React from 'react';

function WebsiteEmbed() {
  return (
    <div>
      <iframe
        title="website-embed"
        src="https://recover-community.netlify.app/"
        width="100%"
        height="700px"
        frameBorder="0"
      />
    </div>
  );
}

export default WebsiteEmbed;
